import Feature from 'vue-feature-toggle';

Feature.install = (Vue) => {
  Vue.prototype.$feature = Feature;
}

declare interface FeatureObject {
  isVisible: (feature: string) => boolean
}

declare module 'vue/types/vue' {
  interface Vue {
    $feature: FeatureObject
  }
}

export default Feature;



// WEBPACK FOOTER //
// ./src/misc/external/feature.ts